import axios from 'axios';
import { API_BASE_URL, handleApiError } from './_apiBase';

// ── Användare ────────────────────────────────────────────────────────────────

/** En rad från /users. */
export interface UserRecord {
    id: number;
    username: string;
    email: string | null;
    userLevel: 'admin' | 'read';
    timezone: string;
    enabled: boolean;
    createdAt: string;
    updatedAt?: string;
}

export type UserInput = Partial<Pick<UserRecord, 'username' | 'email' | 'userLevel' | 'timezone' | 'enabled'>> & { password?: string };

export const fetchAllUsers = async (): Promise<UserRecord[]> => {
    try { return (await axios.get<UserRecord[]>(`${API_BASE_URL}/users`)).data; }
    catch (e) { return handleApiError(e, 'Hämta användare'); }
};

export const createUser = async (input: UserInput): Promise<UserRecord> => {
    try { return (await axios.post<UserRecord>(`${API_BASE_URL}/users`, input)).data; }
    catch (e) { return handleApiError(e, 'Skapa användare'); }
};

export const updateUser = async (id: number, input: UserInput): Promise<void> => {
    try { await axios.put(`${API_BASE_URL}/users/${id}`, input); }
    catch (e) { return handleApiError(e, 'Spara användare'); }
};

export const deleteUser = async (id: number): Promise<void> => {
    try { await axios.delete(`${API_BASE_URL}/users/${id}`); }
    catch (e) { return handleApiError(e, 'Ta bort användare'); }
};
